module.exports = __webpack_public_path__ + "img/thumb_2021-05.8150a62d.jpg";